"use strict";function sendEmotion$(d){return ddSdk_1.ddSdk.invokeAPI(apiName,d)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.sendEmotion$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.chat.sendEmotion";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"4.6.12"},_a[ddSdk_1.ENV_ENUM.android]={vs:"4.6.12"},_a)),exports.sendEmotion$=sendEmotion$,exports.default=sendEmotion$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/chat/sendEmotion.js
// module id = 921
// module chunks = 106